<template>
  <v-container>
    <v-card class="mx-auto">
      <v-card-title>
        Payments
        <v-spacer />
        <v-btn
          color="indigo lighten-1"
          class="white--text payments--button"
          @click="downloadLink(proforma)"
        >
          Print {{ "Proforma" }}
          <v-icon class="mx-2">print</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12" md="8" lg="8" sm="12" xs="12">
            <v-tabs v-model="tabs">
              <v-tab>Application Proforma</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <pdf :src="proforma" />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
          <v-divider vertical />
          <v-col cols="12" md="4" lg="4" sm="12" xs="12" class="py-16">
            <v-card-title>Summary</v-card-title>
            <v-list dense>
              <v-list-item-group>
                <v-list-item>
                  <v-list-item-title>Amount</v-list-item-title>
                  <v-list-item-subtitle
                    >Ksh
                    {{
                      application.amountToInvoice !== 0
                        ? application.amountToInvoice
                        : 1
                    }}</v-list-item-subtitle
                  >
                </v-list-item>
              </v-list-item-group>
            </v-list>
            <v-divider class="my-3"></v-divider>
            <v-form v-model="isValid" ref="checkoutForm">
              <v-text-field
                placeholder="Enter Your Name"
                label="Name"
                persistent-placeholder
                prepend-inner-icon="person"
                dense
                v-model="name"
                clearable
                :rules="[rules.required]"
                outlined
              ></v-text-field>
              <vue-tel-input-vuetify
                required
                clearable
                placeholder="Enter Mpesa Phone Number"
                label="Phone Number"
                autofocus
                :inputOptions="{
                  showDialCode: true,
                  tabindex: 1,
                }"
                outlined
                dense
                v-model="phone"
                defaultCountry="KE"
                :onlyCountries="['KE', 'UG', 'TZ']"
                :rules="[rules.phone]"
              ></vue-tel-input-vuetify>
              <v-btn color="primary" class="mt-10" block @click="pay">
                <v-icon class="mx-2">credit_card</v-icon>
                pay
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import pdf from "vue-pdf";
import FileMixin from "../../dashboard/mixin/FileMixin";
import { AuthService } from "@brainspore/celadon-base/modules/auth";
export default {
  name: "PaymentsComponent",
  mixins: [FileMixin],
  components: { pdf },
  data: function () {
    return {
      phone: "",
      name: "",
      isValid: false,
      tabs: null,
      rules: {
        phone: (v) =>
          /^(\+\d{1,4}\s)?\(?\d{3}\)?[\s.-]\d{6,}$/.test(v) ||
          "Please enter a valid phone number",
        required: (v) => !!v || "Field is required",
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch(
        "Application/getApplicationProforma",
        atob(v.$route.params.app),
      );
      v.$store.dispatch(
        "Application/getServiceRequest",
        atob(v.$route.params.app),
      );
      v.$store.dispatch(
        "Application/getApplications",
        v.user.profile.profileID,
      );
    });
  },
  computed: {
    proforma: function () {
      return this.$store.getters["Application/appGetters"]("proforma");
    },
    application: function () {
      return this.$store.getters["Application/appGetters"]("application");
    },
    serviceRequest: function () {
      return this.$store.getters["Application/appGetters"]("serviceRequest");
    },
    user() {
      return AuthService.user;
    },
  },
  methods: {
    logout: () => {
      AuthService.logout();
    },
    pay: function () {
      if (!this.isValid) {
        this.$refs.checkoutForm.validate();
      } else {
        const PhoneNo =
          this.user.profile.phoneNo.charAt(0) === "+"
            ? this.user.profile.phoneNo.slice(1)
            : this.user.profile.phoneNo.charAt(0) === "0"
              ? `254${this.user.profile.phoneNo.slice(1)}`
              : this.user.profile.phoneNo;
        this.$confirm.show({
          title: "Confirm Payment",
          rejectLabel: "Pay Later",
          text: `Confirm Payment for application No. ${this.serviceRequest.no}`,
          onConfirm: () => {
            console.log("Comfirmed");
            let payload = {
              payerID: this.name,
              sourceDocumentNo: this.serviceRequest.no,
              serviceID: this.serviceRequest.serviceRequestCode,
              description: "Application Payment",
              amount:
                this.application["amountToInvoice"] === 0
                  ? "1"
                  : this.application["amountToInvoice"].toString(),
              accountNo: PhoneNo,
              email: this.user.profile.email,
              idNumber: this.user.profile.identificationDocumentNo,
              name: `${this.user.profile.firstName} ${this.user.profile.lastName}`,
              success_url: `${process.env.VUE_APP_URL}${
                this.$router.resolve({ name: "Summary" }).href
              }`,
              fail_url: window.location.href,
            };

            payload = btoa(JSON.stringify(payload));
            // window.location.href = `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`;
            this.$checkout.pay(payload);
          },
          onCancel: () => {
            this.$router.replace({ name: "Summary" });
          },
        });
      }
    },
  },
};
</script>
<style>
.payments--button > .v-btn__content {
  font-size: 16px;
  text-transform: none;
}
</style>
